module.exports = __webpack_public_path__ + "img/icon_tips.9797edf3.svg";